import axios from 'axios'
import router from '@/router'
import { parseError, logError } from '@/utils/errorHandler'

// instance
const authRequest = axios.create({
  baseURL: process.env.VUE_APP_API_HOST + '/admin',
  timeout: 5000,
  headers: {'Authorization': localStorage.getItem('uid')}
});

const deAuth = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 5000,
  headers: {'Authorization': localStorage.getItem('uid')}
});

const plainRequest = axios.create({
  baseURL: process.env.VUE_APP_API_HOST,
  timeout: 5000,
});

/**
 * Interceptor for request - updates Authorization header with latest token
 */
const authRequestInterceptor = (config) => {
  config.headers.Authorization = localStorage.getItem('uid')
  return config
}

/**
 * Interceptor for successful response - returns response as-is
 */
const responseInterceptor = (response) => {
  return response
}

/**
 * Interceptor for error response - handles different HTTP status codes
 */
const errorInterceptor = (error) => {
  const parsedError = parseError(error)
  
  // Log error for debugging
  logError(error.config?.url || 'API Call', parsedError)
  
  // Handle 401 Unauthorized - redirect to login
  if (parsedError.statusCode === 401) {
    localStorage.removeItem('uid')
    localStorage.removeItem('user_data')
    router.push({ name: 'login' })
    return Promise.reject(parsedError)
  }
  
  // Handle 403 Forbidden - redirect to unauthorized page
  if (parsedError.statusCode === 403) {
    console.warn('Access denied. You do not have permission.')
    // Add a flag to indicate this is a handled redirect
    parsedError.isRedirecting = true
    router.push({ name: 'unauthorized' })
  }
  
  return Promise.reject(parsedError)
}

// Apply interceptors to authRequest
authRequest.interceptors.request.use(authRequestInterceptor)
authRequest.interceptors.response.use(responseInterceptor, errorInterceptor)

// Apply interceptors to deAuth
deAuth.interceptors.request.use(authRequestInterceptor)
deAuth.interceptors.response.use(responseInterceptor, errorInterceptor)

// plainRequest uses default response handling
plainRequest.interceptors.response.use(responseInterceptor, errorInterceptor)

export { authRequest, plainRequest, deAuth };